export enum BigSymbolFreegamesContainer {
	IntroMessage,
	Reels,
	FinalMessage
}